import { useContext } from 'react';
import { Box, Typography, Link, Grid, SvgIcon } from '@mui/material'
import { ReactComponent as faceBookIcon } from '../../assets/icons/rifacebookfill.svg';
import { ReactComponent as instagramIcon } from '../../assets/icons/mdiinstagram.svg';
import { ReactComponent as linkedInIcon } from '../../assets/icons/rilinkedinfill.svg';
import { ReactComponent as youtubeIcon } from '../../assets/icons/mdiyoutube.svg';
import { DataContext } from '../../../../contexts/data/dataContext'
import custom from '../../../../styles/mui/szVariables.json'
import { analyticsCta, analyticsDomain } from '../../../../services/constants'
import { sendClickAnalytics } from '../../../common/util/util'

export default function Footer() {
    const border = custom.border
    const data = useContext(DataContext)

    const handleClick = (id: string, url: string) =>{
        let name = id;
        if(id==='tnc') name = analyticsCta.termsAndConditions
        if(id==='pp') name = analyticsCta.privacyPolicy
        sendClickAnalytics('/profile',{
              domain: analyticsDomain.profile,
              name,
              metadata: {},
          })
        window.open(url, "_blank")
    }

    if(!data?.customer) return null;
    return (
        <Box id="footer"
            sx={{  
                backgroundColor:'sz.colors.background', 
                borderTop: border, 
                boxSizing: 'border-box',
                // borderBottom: custom.borderRed,
                height: { 
                    xs: 'auto', 
                    sm: custom.sizes.hf, 
                    md: custom.sizes.hf, 
                    lg: custom.sizes.hf,
                    xl: custom.sizes.hf
                },
                // display: data?.rightPanel?'none':'flex',
                display: {
                    xs: `${data?.rightPanel?.key!=='help'?
                                            "flex":"none"}`,
                    sm: 'flex',
                    md: 'flex',
                    lg: data?.rightPanel?'none':'flex',
                    xl: data?.rightPanel?'none':'flex',
                    xxl: data?.rightPanel?'none':'flex'   
                },
                flexDirection:"row",
                justifyContent:"center",
                alignContent: "center",
                width: '100%',
                // maxWidth: "1200px",
                zIndex: 9,
                mt: 'auto',
                bottom: 0,
                position: {
                    xs: 'relative', 
                    sm: data?.rightPanel?'fixed':'relative', 
                    md: data?.rightPanel?'fixed':'relative',
                    lg: 'relative',
                    xl: 'relative',
                    // lg: `${data?.rightPanel?'fixed':'relative'}`,
                    // xl: `${data?.rightPanel?'fixed':'relative'}`,
                }
            }}>

            <Grid container                
                alignItems="center" 
                justifyContent="center"
                direction="row" 
                columnSpacing={0} 
                maxWidth="1200px"
                rowSpacing={{
                    xs: 3, 
                    sm: 0, 
                    md: 0, 
                    lg: 0
                }} 
                px={custom.spacing.md}
                >
                <Grid item xs={12} sm={4} md={4} lg={4} 
                    mt={{
                        xs: custom.spacing.md,
                        sm:0,md:0,lg:0
                    }}
                    justifyContent={{ 
                        xs: "center", 
                        sm:"flex-start", 
                        md:"flex-start", 
                        lg:"flex-start"
                    }} 
                    alignItems="center" display="flex">
                    <Typography variant="szBody.Regular.Small" 
                        color="text.primary" align="center" noWrap>
                        © SolarZero {(new Date()).getFullYear()}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} 
                    justifyContent="center" 
                    alignItems="center" 
                    display="flex">
                    <Box alignContent="center" display="flex">
                        <Link target="_blank" rel="noopener" 
                            href="https://www.facebook.com/solarZeronz" 
                            underline="none" color="inherit" pr={3} >
                            <SvgIcon component={faceBookIcon} inheritViewBox />
                        </Link>
                        <Link target="_blank" rel="noopener" 
                            href="https://www.instagram.com/solarzero_nz" 
                            underline="none" color="inherit" mr={3}>
                            <SvgIcon component={instagramIcon} inheritViewBox />
                        </Link>
                        <Link target="_blank" rel="noopener" 
                            href="https://www.linkedin.com/company/solarzeronz/" 
                            underline="none" color="inherit" >
                            <SvgIcon component={linkedInIcon} inheritViewBox />
                        </Link>
                        <Link target="_blank" rel="noopener" 
                            href="https://www.youtube.com/channel/UC6r_odiDT1JEygJR-2S9B8g" 
                            underline="none" color="inherit" ml={3}>
                            <SvgIcon component={youtubeIcon} inheritViewBox />
                        </Link>
                   </Box>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} 
                        justifyContent={{   
                            xs: "center", 
                            sm:"flex-end", 
                            md:"flex-end", 
                            lg:"flex-end",
                        }} 
                        pb={{
                            xs: custom.spacing.sm,
                            sm:0,
                            md:0,
                            lg:0,
                            xl:0
                        }}                
                        alignItems="center" 
                        display="flex"
                        width="100%">
                    <Typography variant="szBody.Regular.Small" 
                        color="text.primary" align="center" noWrap>
                        <Link target="_blank" rel="noopener" 
                            onClick={
                                ()=>handleClick('tnc',"https://www.solarzero.co.nz/terms-and-conditions")
                            }
                            href="#" 
                            underline="none" color="inherit" mr={1}>{`T&Cs`} 
                        </Link>
                        <span>•</span> 
                        <Link target="_blank" rel="noopener" 
                            onClick={
                                ()=>handleClick('pp',"https://www.solarzero.co.nz/privacy-policy")
                            }
                            href="#"
                            underline="none" color="inherit" ml={1}> 
                                Privacy Policy 
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <Box display={data?.rightPanel?'block':'none'} 
              width={{ 
                  xs: 0, 
                  sm: 0, 
                  md: 0, 
                  lg: '400px', 
                  xl: '400px' }}
              />
        </Box>
        );
}
